// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "." + {"56":"68920b08","176":"9f0e798c","466":"341032e8"}[chunkId] + ".js";
};